var map = {
	"./clubs.png": "9708",
	"./diamonds.png": "0abe",
	"./hearts.png": "3a2b",
	"./logo.png": "cf05",
	"./refresh.png": "684f",
	"./settings.png": "3e4e",
	"./spades.png": "11a5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9e01";